<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-dialog
    v-model="dialog"
    persistent
    id="createTaskFromSurvey"
    width="400px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title class="py-6">
        <div
          class="text-h6 text-sm-h4"
          style="word-break: break-word;"
        > {{ language.t('SurveyToTask.createTask') }}
        </div>
        <v-spacer></v-spacer>
        <v-btn
          icon
          color="blue darken-1"
          @click="$emit('close');"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-alert
          v-if="error"
          type="error"
          dismissible
          max-width="350px"
        >{{ errorMessage }}</v-alert>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          v-on:submit.prevent="createTask"
        >
          <v-text-field
            v-model="form.taskName"
            :label="language.t('SurveyToTask.taskname')"
            :rules="[(v) => !!v || language.t('SurveyToTask.tasknameRequired'),
            (v) => v.length <= 45 || language.t('SurveyToTask.tasknameTooLong'),]"
          >
          </v-text-field>
          <v-btn
            color="success"
            class="mr-4"
            type="submit"
            :disabled="!valid"
            :loading="saving"
          >
            {{ language.t('App.save') }}
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},
  props: { task: null },
  data() {
    return {
      dialog: true,
      valid: true,
      saving: false,
      complete: true,
      error: false,
      errorMessage: null,
      form: {
        taskName: this.task.name,
      },
    };
  },
  mounted: function () {},
  computed: {},
  watch: {},
  methods: {
    createTask() {
      this.saving = true;
      this.$axios.post(route("api.tasks.exportnewtask", { taskId: this.task.taskId, newTaskName: this.form.taskName })).then((res) => {
        console.log(res);
        this.$emit("update");
        this.saving = false;
        this.$emit("close");
      });
    },
  },
};
</script>
<style scoped>
.v-alert__content {
  font-size: 12px;
}
</style>